import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../../services/camps-enum-translation.service';
import { campsenum } from '../../../../../models/enums.generated';

@Component({
    selector: 'app-acquired-session-item',
    templateUrl: './acquired-session-item.component.html',
    styleUrls: ['./acquired-session-item.component.scss'],
    standalone: false
})
export class AcquiredSessionItemComponent implements OnInit {

    @Input()
    public item: camps.PurchasedSessionInfo;

    public isPopverVisible = false;

    constructor(private translateService: CampsEnumTranslationService) { }

    ngOnInit() {
    }

    timeVariant() {
        return this.translateService.timeVariant(this.item.timeVariant.type);
    }

    public onExplanationMouseOver(){
        this.isPopverVisible = true;
    }

    public onExplanationMouseOut(){
         this.isPopverVisible = false; 
    }

    refundReason(reason: campsenum.RefundReason): string {
        return this.translateService.refundReason(reason ?? this.item.refundReasonInfo.reason);
    }
}
